import ToastEventBus from 'primevue/toasteventbus';

export const useToastService = () => {
    const showToast = (error) => {
        ToastEventBus.emit('add', error);
    };

    return { showToast };
};
